import { useState } from 'react';

import { ShippingSearchContext } from './_context';

import ShippingPendingComponent from './ShippingSearchComponent';

const ShippingPendingContainer = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [dropdownOptionsChannels, setDropdownOptionsChannels] = useState('');
  const [selectChannel, setSelectChannel] = useState('');

  const shippingValues = {
    modalOpen,
    setModalOpen,
    dropdownOptionsChannels,
    setDropdownOptionsChannels,
    selectChannel,
    setSelectChannel,
  };

  return (
    <ShippingSearchContext.Provider value={shippingValues}>
      <ShippingPendingComponent />
    </ShippingSearchContext.Provider>
  );
};

export default ShippingPendingContainer;
